import moment from 'moment'

import Contract from 'modules/contracts/lib/Contract'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

const calculateContracts = (sortedContractVersions: ContractVersion[]): Contract[] => {
  return sortedContractVersions.reduce((contracts: Contract[], contractVersion) => {
    // If is the first version we need to create a contract
    if (contracts.length === 0)
      contracts.unshift(new Contract(contractVersion.attributes.starts_on || ''))

    // End date is inclusive. Thus, we take next day as reference
    const firstDayWithoutContract = contracts[0]!.endsOn?.clone().add(1, 'day')
    if (
      firstDayWithoutContract &&
      firstDayWithoutContract.isBefore(contractVersion.attributes.effective_on)
    ) {
      // Adding in first position as contracts are shown from newest to oldest
      contracts.unshift(new Contract(contractVersion.attributes.starts_on || ''))
    }

    contracts[0]!.pushVersion(contractVersion)
    contracts[0]!.endsOn = contractVersion.attributes.ends_on
      ? moment(contractVersion.attributes.ends_on)
      : null

    return contracts
  }, [])
}

export default calculateContracts
